import type { StateCreator } from 'zustand'

import type { AfterSaleState } from './types'

const createAfterSaleSlice: StateCreator<AfterSaleState, [], [], AfterSaleState> = (set) => ({
  afterSaleConfig: undefined,
  setAfterSaleConfig: (config) => set(() => ({ afterSaleConfig: config })),
  resetAfterSaleConfig: () => set(() => ({ afterSaleConfig: undefined })),
})

export default createAfterSaleSlice
